/* eslint-disable camelcase */
import {StoreStatus} from '../api/storesApi';

export type StoreCustomizations = {
  logoImageUrl: string;
  heroImageUrl: string;
  bannerColor: string;
  textColor: string;
  headerTransparent: boolean;
  headerLogoType: 'text' | 'logo' | 'custom_ink_branding';
  heroLogoVisibility:
    | 'hidden'
    | 'hero_logo'
    | 'hero_background'
    | 'hero_logo_and_background';
  storeOwnerEmail: string;
  description: string;
  companyUrl: string;
};

export enum ShippingType {
  IndividualShipping = 'individual',
  HybridShipping = 'hybrid',
  BulkShipping = 'bulk'
}

export type StorePresentationConfig = {
  shippingType: ShippingType | null;
};

export type StoreFulfillViaType = 'wave' | 'wholesale';

export type StoreFeatureFlags = {
  addFromCatalog?: boolean;
  deleteProductsEnabled?: boolean;
};

export type StoreConfigAttributes = {
  bannerEnabled: boolean;
  bannerText: string;
};

export type CampaignAttributes = {
  name: string;
  id: number;
  totalItemsQuantity: number;
  expectedQuantity: number;
  closesAt: string;
  createdAt: string;
  status: string;
  replacement: boolean;
  reopenable: boolean;
  closingSoon: boolean;
  timeRemainingInWords: string;
  organizerFirstName: string;
  organizerLastName: string;
  organizerPhoneNumber: string;
};

export type StoreCampaignAttributes = {
  eventStore: boolean;
  campaigns: CampaignAttributes[];
};

export type StoreCapabilities = [
  setCloseDate: string,
  cancelCampaign: string,
  configureDelivery: string,
  configurePayment: string,
  configureAutoFulfill: string,
  configureContactDetails: string,
  configureGroupCommunication: string
];

export interface StoreDetails
  extends Partial<StoreCustomizations>,
    Partial<StoreCampaignAttributes>,
    Partial<StoreConfigAttributes>,
    Partial<StorePresentationConfig>,
    Partial<StoreFeatureFlags> {
  name: string;
  status: StoreStatus;
  fulfillVia: StoreFulfillViaType;
  capabilities: StoreCapabilities;
  createdVia: StoreCreatedViaType;
  designCompositeId?: string;
}

type PendingImageDetails = {
  [key in StoreImageType]?: string;
};
export type PendingStoreDetails = Partial<
  Omit<StoreDetails, 'logoImageUrl' | 'heroImageUrl'>
> &
  PendingImageDetails;

export type StoreUpdateParamsType = PendingStoreDetails & {urlSlug?: string};

export type StoreDetailKey = keyof StoreDetails;

export type StorePendingDetailKey = keyof PendingStoreDetails;

export type StoreImageType = 'logo' | 'heroImage';

export type StoreImageUrlType = 'logoImageUrl' | 'heroImageUrl';

type StoreImageToUrlType = {
  [key in StoreImageType]: StoreImageUrlType;
};

export type BannerFillType = 'solidColor' | 'image' | 'none' | 'custom';

export type OnlineStoreType = 'loading' | 'selfServe' | 'event';

export type StoreCreatedViaType = 'internal' | 'self_serve' | 'groups';

export const imageTypeToUrl: StoreImageToUrlType = {
  logo: 'logoImageUrl',
  heroImage: 'heroImageUrl'
};
